import { Button } from "../ui/button";

interface JoinUsSectionProps {
  title?: string;
}

export const JoinUsSection = ({
  title = "Se interessou em trabalhar conosco? Junte-se a nós.",
}: JoinUsSectionProps) => {
  return (
    <section id="banner" className=" py-10 md:py-24">
      <div className="container">
        <div className="flex flex-col md:p-[80px] p-10 rounded-[20px] items-center justify-center gap-6 bg-n-bg-green">
          <h2
            className="text-4xl md:text-5xl text-n-text-beige max-w-3xl text-center"
            style={{ fontFamily: "'Anton', sans-serif", lineHeight: "1.2em" }}
          >
            {title}
          </h2>
          <a
            href="https://www.linkedin.com/company/nacional-go/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button>Ver vagas</Button>
          </a>
        </div>
      </div>
    </section>
  );
};
